import React from 'react'
import { useLanguage } from '../i18n/LanguageContext'
import type { Language } from '../i18n/translations'

const options: { code: Language; label: string; full: string }[] = [
  { code: 'hr', label: 'HR', full: 'Hrvatski' },
  { code: 'en', label: 'EN', full: 'English' }
]

export default function LanguageToggle({ className = '' }: { className?: string }) {
  const { language, setLanguage } = useLanguage()

  return (
    <div
      role="group"
      aria-label="Language / Jezik"
      className={`inline-flex items-center rounded-full p-0.5 ${className}`}
      style={{ border: '1px solid rgba(118,128,100,0.35)', backgroundColor: '#ffffff' }}
    >
      {options.map((option) => {
        const isActive = option.code === language
        return (
          <button
            key={option.code}
            type="button"
            onClick={() => setLanguage(option.code)}
            aria-pressed={isActive}
            title={option.full}
            className="px-3 py-1.5 text-xs font-semibold rounded-full transition-all focus:outline-none focus:ring-2 focus:ring-offset-1"
            style={
              isActive
                ? { backgroundColor: 'var(--medispa-olive)', color: '#ffffff' }
                : { backgroundColor: 'transparent', color: 'var(--medispa-moss)' }
            }
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}
